var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputSelect',{class:_vm.classAnother,attrs:{"model":_vm.value,"input_class":'w-full select-large' + _vm.classAnother,"label":_vm.label,"options":_vm.nationOptions},on:{"update:model":function($event){_vm.value=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }